@let data = $data();
<div class="main-container relative w-full flex flex-col gap-[var(--gap-small)] bg-white" [class.open]="$show()" >
  <app-icon class="top-right-icon absolute top-[5px] right-[6px]" icon="account-voice" color="--secondary" [scale]=".8" />

  <div class="icons-panel flex flex-col gap-[var(--gap-large)]">
    <div class="icons-panel-texts flex flex-col">
     @if (data && data.title) {
      <p>{{ data.title }}</p>
     }
     @else {
      <p class="invisible">&nbsp;</p>
     }

     @if (data && data.subtitle) {
      <small>{{ data.subtitle }}</small>
     }
     @else {
      <small class="invisible">&nbsp;</small>
     }
    </div>

    <div class="icon-buttons">
     @for (button of $actionIcons(); track button) {
      <app-button
        iconColor="--white"
        innerPadding="5px"
        iconSize="20px"
        [icon]="button.icon"
        (click)="button.callback && button.callback()"
      />
     }
    </div>
  </div>

  <div class="flex flex-col gap-[var(--gap-small)]">
   @for(item of $openCloseItems(); track item) {
    <div class="accordion flex flex-col items-center gap-[var(--gap-small)] !p-[2px]">
      <app-open-close
        text="{{ item.text }}"
        [icon]="item.icon"
        [iconSize]="item.iconSize ?? ''"
        [iconScale]="item.iconScale ?? 1"
        [iconViewBoxAdjustmentX]="item.iconViewBoxAdjustmentX ?? 0"
        [iconViewBoxAdjustmentY]="item.iconViewBoxAdjustmentY ?? 0"
        [open]="item.open"
        (valueChange)="item.open = $event"
      />
      @if (item.open) {
      <div appCard dirBorder="small" class="w-full flex flex-col items-center">
       @if ($loading() || item.contentLoading) {
        <app-spinner size="20px" borderWidth="4.5px" />
       }
       @else {
        <app-summary-lateral-panel [moduleName]="$moduleName()" [panelName]="item.panelName" />
       }
      </div>
      }
    </div>
   }
  </div>
</div>
